
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import ServicesSection from './components/ServicesSection';
import FeaturedWork from './components/FeaturedWork';

export default function Home() {
  useEffect(() => {
    // Update document title and meta tags
    document.title = "Esteban's Stache";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn about my background, experience, and creative journey as a photographer of 20+ years and a designer with 8+ years of experience in brand identity, visual strategy, and design solutions. Based in Los Angeles, working with purpose-driven brands worldwide.');
    }
    
    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', '/');
    }
    
    // Add Schema.org JSON-LD for WebPage
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Esteban's Stache - Creative Designer & Photographer",
        "description": "Learn about my background, experience, and creative journey as a photographer of 20+ years and a designer with 8+ years of experience in brand identity, visual strategy, and design solutions. Based in Los Angeles, working with purpose-driven brands worldwide.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
        "mainEntity": {
          "@type": "Person",
          "name": "Esteban",
          "jobTitle": "Creative Designer & Photographer",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Los Angeles",
            "addressRegion": "CA",
            "addressCountry": "US"
          }
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
            }
          ]
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <PhilosophySection />
        <ServicesSection />
        <FeaturedWork />
      </main>
      <Footer />
    </div>
  );
}
